// Group strings by parent
export function groupByParent(data: string[]) {
  const groups: Record<string, string[]> = {};
  data.forEach(item => {
    const [parent, child] = item.split(':');
    if (!groups[parent]) {
      groups[parent] = [];
    }
    groups[parent].push(`${parent}:${child}`);
  });
  return groups;
};
